import React from 'react';
import {reset} from 'redux-form';
import {connect} from 'react-redux'
import {Link} from 'react-router-dom';
import { stopSubmit, formValueSelector } from 'redux-form'
import Paper from 'material-ui/Paper';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentCreate from 'material-ui/svg-icons/content/create';
import ContentRemove from 'material-ui/svg-icons/content/remove';
import * as colors from 'material-ui/styles/colors';

import Loading from '../../components/Loading';

import $ from 'jquery'

import moment from 'moment'

import PageBase from '../../components/PageBase';
import DataTables from '../../components/DataTables/DataTables'

import listHeader from './listHeader'
import gStyles from '../../styles'

import RoumuDownloadForm from './RoumuDownloadForm'

import * as actions from '../../actions'


class RoumuDownloadPage extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      loading: false
    }
  }

  componentDidMount() {

    window.scrollTo(0, 0)

    $.ajaxTransport("+binary", function(options, originalOptions, jqXHR){
      // check for conditions and support for blob / arraybuffer response type
      if (window.FormData && ((options.dataType && (options.dataType == 'binary')) || (options.data && ((window.ArrayBuffer && options.data instanceof ArrayBuffer) || (window.Blob && options.data instanceof Blob)))))
      {
        return {
          // create new XMLHttpRequest
          send: function(headers, callback){
            // setup all variables
            var xhr = new XMLHttpRequest(),
              url = options.url,
              type = options.type,
              async = options.async || true,
              // blob or arraybuffer. Default is blob
              dataType = options.responseType || "blob",
              data = options.data || null,
              username = options.username || null,
              password = options.password || null;

            xhr.addEventListener('load', function(){
              var data = {};
              data[options.dataType] = xhr.response;
              // make callback and send data
              callback(xhr.status, xhr.statusText, data, xhr.getAllResponseHeaders());
            });

            xhr.open(type, url, async, username, password);

            // setup custom headers
            for (var i in headers ) {
              xhr.setRequestHeader(i, headers[i] );
            }

            xhr.responseType = dataType;
            xhr.send(data);
          },
          abort: function(){
            jqXHR.abort();
          }
        };
      }
    });

  }

  handleDownloadEnd() {
    this.setState(Object.assign(this.state, {loading: false}));
  }

  handleDownloadStart() {
    this.setState(Object.assign(this.state, {loading: true}));
  }

  handleDownload(auth, match, start, end, showErrorMessage) {

    return function(values) {

      start()

      const userId = match.params.userId || auth.user.id
      const userName = match.params.userName || decodeURI(auth.user.name)

      let requestYear = values.year;
      if (values.month == 12) {
        requestYear = values.year - 1;
      }

      $.ajax({
        url: `/bg/kinmu/report?userId=${userId}&year=${requestYear}&month=${values.month}`,
        dataType: "binary",
        processData: false,
        error: function () {
          end()
          showErrorMessage()
        },
        success: function (data) {
          end()

          let dispMonth;
          if (values.month == 12) {
            dispMonth = 1;
          } else {
            dispMonth = values.month + 1;
          }

          const name = `timecard_${values.year}_${dispMonth}_${userName}.xlsx`
          const mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=UTF-8'

          let blob = new Blob([data], {type: mimeType})
          let downloadUrl = URL.createObjectURL(blob);

          let a = document.createElement("a");
          a.href = downloadUrl
          a.download = name
          // a.target = '_blank'

          if (window.navigator.msSaveBlob) {
            // for IE
            window.navigator.msSaveBlob(blob, name)
          } else if (window.URL && window.URL.createObjectURL) {
            // for Firefox
            a.href = window.URL.createObjectURL(blob);
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          } else if (window.webkitURL && window.webkitURL.createObject) {
            // for Chrome
            a.href = window.webkitURL.createObjectURL(blob);
            a.click();
          } else {
            // for Safari
            window.open('data:' + mimeType + ';base64,' + window.Base64.encode(data), '_blank');
          }

        },
        type: 'GET'
      });

    }

  }


  handleDownloadPdf(auth, match, start, end, showErrorMessage) {

    return function(values) {

      start()

      const userId = match.params.userId || auth.user.id
      const userName = match.params.userName || decodeURI(auth.user.name)

      let requestYear = values.year;
      if (values.month == 12) {
        requestYear = values.year - 1;
      }
          
      $.ajax({
        url: `/bg/kinmu/report/pdf?userId=${userId}&year=${requestYear}&month=${values.month}`,
        dataType: "binary",
        processData: false,
        error: function () {
          end()
          showErrorMessage()
        },
        success: function (data) {
          end()

          let dispMonth;
          if (values.month == 12) {
            dispMonth = 1;
          } else {
            dispMonth = values.month + 1;
          }

          const name = `timecard_${values.year}_${dispMonth}_${userName}.pdf`
          const mimeType = 'application/pdf'

          let blob = new Blob([data], {type: mimeType})
          let downloadUrl = URL.createObjectURL(blob);

          let a = document.createElement("a");
          a.href = downloadUrl
          a.download = name
          // a.target = '_blank'

          if (window.navigator.msSaveBlob) {
            // for IE
            window.navigator.msSaveBlob(blob, name)
          } else if (window.URL && window.URL.createObjectURL) {
            // for Firefox
            a.href = window.URL.createObjectURL(blob);
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          } else if (window.webkitURL && window.webkitURL.createObject) {
            // for Chrome
            a.href = window.webkitURL.createObjectURL(blob);
            a.click();
          } else {
            // for Safari
            window.open('data:' + mimeType + ';base64,' + window.Base64.encode(data), '_blank');
          }

        },
        type: 'GET'
      });

    }

  }

  render() {

    const {
      auth,
      match
    } = this.props

    let userName = match.params.userName || auth.user.name
    if (userName) {
      userName = decodeURI(userName)
    }

    return (

      <PageBase title={`タイムカード（${userName}）`}>

        <div>

          <div style={gStyles.searchBoxContainer}>

            <Paper style={{...gStyles.contentsPaper}}>
              <RoumuDownloadForm
                auth={auth}
                onDownload={this.handleDownload(auth, match, this.handleDownloadStart.bind(this), this.handleDownloadEnd.bind(this), this.props.showErrorMessage).bind(this)}
                onDownloadPdf={this.handleDownloadPdf(auth, match, this.handleDownloadStart.bind(this), this.handleDownloadEnd.bind(this), this.props.showErrorMessage).bind(this)}
              />
            </Paper>

          </div>

        </div>

        <Loading open={this.state.loading}/>

      </PageBase>

    )
  }

}

const mapStateToProps = (state) => ({
  auth: state.auth,
})

const mapStateToDispatch = (dispatch) => ({
  showErrorMessage: () => {actions.reducerSnackBar(true, '通信処理に失敗しました。', colors.red400)}
})

RoumuDownloadPage = connect(
  mapStateToProps,
  mapStateToDispatch
)(RoumuDownloadPage)

export default RoumuDownloadPage;



// WEBPACK FOOTER //
// ./src/containers/roumu/RoumuDownloadPage.js